import { ErrorPage } from "@/components/error-page/error-page";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";

interface ErrorViewProps {
  errorMsg: string;
  showBackButton?: boolean;
  showReloadButton?: boolean;
  onHideError?: () => void;
}

export function ErrorView({ errorMsg, showBackButton = true, onHideError }: ErrorViewProps) {
  const { t } = useTranslation("common");
  const [location] = useLocation();
  const errorLocationRef = useRef(location);

  useEffect(() => {
    if (location !== errorLocationRef.current) {
      onHideError?.();
    }
  }, [location, onHideError]);

  return (
    <ErrorPage
      errorCode={500}
      message={t("common:Error")}
      description={t("common:ErrorOccurred", { errorMsg })}
      backToLabel={showBackButton ? t("fit:BackToOverview") : undefined}
    />
  );
}
